export const formatNumberWithFixedDecimals = (num: number | string, fixedPoint: number = 2) => {
    const number = Number(num);
    if (isNaN(number)) return num;
    if (Number.isInteger(number)) return number;
    return parseFloat(number.toFixed(fixedPoint));
}